export default __webpack_public_path__ + "static/media/check-white.cbdf5724.svg";